(function () {
  function setVisible(el) {
    if (!el) return;
    el.style.visibility = 'visible';
    el.style.opacity = '1';
  }

  function mountSplideIfNeeded(root, options) {
    if (!root || !window.Splide) return;

    // prevent double init
    if (root.classList.contains('is-initialized')) return;

    var slides = root.querySelectorAll('.splide__slide');
    var count = slides.length;

    setVisible(root);

    var perPage = (options && options.perPage) ? options.perPage : 1;

    // If not enough slides to slide, keep it static
    if (count <= perPage) {
      root.classList.add('is-static');
      return;
    }

    try {
      new Splide(root, options).mount();
    } catch (e) {
      console.error('Error mounting Splide:', e);
      root.classList.add('is-static');
    }
  }

  function initSectionNavStickyOffset() {
    var nav = document.querySelector('.non-eco-section-nav');
    if (!nav) return;

    // Try common theme selectors; add/remove if your theme uses different header markup
    var header =
      document.querySelector('.header') ||
      document.querySelector('header.site-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');

    var headerH = header ? header.getBoundingClientRect().height : 0;
    // CSS uses --non-eco-sticky-top for sticky offset
    document.documentElement.style.setProperty('--non-eco-sticky-top', headerH + 'px');
  }

  function initProductHeroSplide(scope) {
    var root = (scope || document).querySelector('.product-hero-splide');
    mountSplideIfNeeded(root, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      arrows: true,
      pagination: true,
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      rewind: true
    });
  }

  function initPossibilitiesSplide(scope) {
    var root = (scope || document).querySelector('.non-eco-possibilities__splide');
    mountSplideIfNeeded(root, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      arrows: true,
      pagination: false,
      autoplay: false,
      speed: 500,
      rewind: true
    });
  }

  function initFinishesSplides(scope) {
    var roots = (scope || document).querySelectorAll('.non-eco-finishes__splide');
    roots.forEach(function (root) {
      mountSplideIfNeeded(root, {
        type: 'loop',
        perPage: 5,
        perMove: 1,
        gap: '1.5rem',
        pagination: false,
        arrows: true,
        autoplay: false,
        rewind: true,
        breakpoints: {
          1200: { perPage: 4 },
          992: { perPage: 3 },
          768: { perPage: 2,gap: '8px' },
          480: { perPage: 2,gap: '8px' }
        }
      });
    });
  }

  function initHardwareSplides(scope) {
    var roots = (scope || document).querySelectorAll('.non-eco-hardware__splide');
    roots.forEach(function (root) {
      mountSplideIfNeeded(root, {
        type: 'slide',
        perPage: 5,
        perMove: 1,
        gap: '16px',
        arrows: true,
        pagination: false,
        rewind: true,
        breakpoints: {
          1024: { perPage: 4 },
          768: { perPage: 3 },
          480: { perPage: 2 }
        }
      });
    });
  }

  function initGlassSplides(scope) {
    var roots = (scope || document).querySelectorAll('.glass-options__splide');
    roots.forEach(function (root) {
      mountSplideIfNeeded(root, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '24px',
        arrows: true,
        pagination: false,
        rewind: true,
        breakpoints: {
          1024: { perPage: 2 },
          768: { perPage: 1 },
          480: { perPage: 1 }
        }
      });
    });
  }

  function initNonEcoFinishesModal(scope) {
    var section = (scope || document).querySelector('.non-eco-finishes');
    if (!section) return;

    var modal = section.querySelector('.non-eco-finishes__modal');
    if (!modal) return;

    var modalImg = modal.querySelector('.non-eco-finishes__modal-img');
    var modalTitle = modal.querySelector('.non-eco-finishes__modal-title');
    var modalDesc = modal.querySelector('.non-eco-finishes__modal-description');
    var backdrop = modal.querySelector('.non-eco-finishes__modal-backdrop');
    var closeBtn = modal.querySelector('.non-eco-finishes__modal-close');

    function openModal(swatch) {
      var title = swatch.dataset.finishTitle || '';
      var imageUrl = swatch.dataset.finishImage || '';
      var descSource = swatch.querySelector('.non-eco-finishes__detail-source');

      modalTitle.textContent = title;

      if (imageUrl) {
        modalImg.src = imageUrl;
        modalImg.alt = title;
      } else {
        modalImg.removeAttribute('src');
        modalImg.alt = '';
      }

      modalDesc.innerHTML = descSource ? descSource.innerHTML : '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('non-eco-finishes__modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('non-eco-finishes__modal-open');
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('.non-eco-finishes__swatch-trigger');
      if (!trigger) return;

      e.preventDefault();
      var swatch = trigger.closest('.non-eco-finishes__swatch');
      if (!swatch) return;

      openModal(swatch);
    });

    [backdrop, closeBtn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initNonEcoHardwareModal(scope) {
    var section = (scope || document).querySelector('.non-eco-hardware');
    if (!section) return;

    var modal = section.querySelector('.non-eco-hardware__modal');
    if (!modal) return;

    var modalImg = modal.querySelector('.non-eco-hardware__modal-img');
    var modalTitle = modal.querySelector('.non-eco-hardware__modal-title');
    var modalDesc = modal.querySelector('.non-eco-hardware__modal-description');
    var backdrop = modal.querySelector('.non-eco-hardware__modal-backdrop');
    var closeBtn = modal.querySelector('.non-eco-hardware__modal-close');

    function openModal(item) {
      var title = item.dataset.hwTitle || '';
      var imageUrl = item.dataset.hwImage || '';
      var descSource = item.querySelector('.non-eco-hardware__detail-source');

      modalTitle.textContent = title;

      if (imageUrl) {
        modalImg.src = imageUrl;
        modalImg.alt = title;
      } else {
        modalImg.removeAttribute('src');
        modalImg.alt = '';
      }

      modalDesc.innerHTML = descSource ? descSource.innerHTML : '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('non-eco-hardware__modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('non-eco-hardware__modal-open');
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('.non-eco-hardware__trigger');
      if (!trigger) return;

      e.preventDefault();
      var item = trigger.closest('.non-eco-hardware__item');
      if (!item) return;

      openModal(item);
    });

    [backdrop, closeBtn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initGlassOptionsModal(scope) {
    var section = (scope || document).querySelector('.glass-options');
    if (!section) return;

    var modal = section.querySelector('.glass-options__modal');
    if (!modal) return;

    var modalImg = modal.querySelector('.glass-options__modal-img');
    var modalTitle = modal.querySelector('.glass-options__modal-title');
    var modalDesc = modal.querySelector('.glass-options__modal-description');
    var backdrop = modal.querySelector('.glass-options__modal-backdrop');
    var closeBtn = modal.querySelector('.glass-options__modal-close');

    function openModal(card) {
      var title = card.dataset.glassTitle || '';
      var imageUrl = card.dataset.glassImage || '';
      var descSource = card.querySelector('.glass-options__detail-source');

      modalTitle.textContent = title;

      if (imageUrl) {
        modalImg.src = imageUrl;
        modalImg.alt = title;
      } else {
        modalImg.removeAttribute('src');
        modalImg.alt = '';
      }

      modalDesc.innerHTML = descSource ? descSource.innerHTML : '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('glass-options__modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('glass-options__modal-open');
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('.glass-options__trigger');
      if (!trigger) return;

      e.preventDefault();
      var card = trigger.closest('.glass-options__card');
      if (!card) return;

      openModal(card);
    });

    [backdrop, closeBtn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }
function initRelatedProductsSplide(scope) {
  var root = (scope || document).querySelector('.non-eco-related-products__splide');
  if (!root) return;

  var slidesCount = root.querySelectorAll('.splide__slide').length;

  var perPageDesktop = 4;

  // 👇 Sirf jab EXACT 4 slides hon
  if (slidesCount === 4) {
    perPageDesktop = 3.2;
  }

  mountSplideIfNeeded(root, {
    type: 'loop',
    perMove: 1,
    gap: '24px',
    arrows: true,
    pagination: false,
    rewind: false,

    perPage: perPageDesktop,

    breakpoints: {
      1200: { perPage: slidesCount === 4 ? 2.5 : 3 },
      768:  { perPage: 2, gap: '12px' },
      480:  { perPage: 1, gap: '12px' }
    }
  });
}



  function initAll(scope) {
    initSectionNavStickyOffset();

    initProductHeroSplide(scope);
    initPossibilitiesSplide(scope);
    initFinishesSplides(scope);
    initHardwareSplides(scope);
    initGlassSplides(scope);

    initNonEcoFinishesModal(scope);
    initNonEcoHardwareModal(scope);
    initGlassOptionsModal(scope);
    initRelatedProductsSplide(scope);

  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    window.addEventListener('resize', initSectionNavStickyOffset);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    initSectionNavStickyOffset();
  });
})();



document.addEventListener("DOMContentLoaded", function () {
    
    let $slider = $('.fullWidthCarouselDescriptionsBlock-slider');

    $slider.slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: "ease-in-out",
        prevArrow: `
          <button type="button" class="slick-arrow slick-arrow--previous" aria-label="Previous slide">
            <svg width="18" height="32" viewBox="0 0 18 32" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 1L2 16L17 31" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>`,
        nextArrow: `
          <button type="button" class="slick-arrow slick-arrow--next" aria-label="Next slide">
            <svg width="18" height="32" viewBox="0 0 18 32" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L16 16L1 31" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>`,
        customPaging: function (slider, i) {
            let caption = slider.$slides.eq(i)
              .find('.fullWidthCarouselDescriptionsBlock-item-image')
              .data('quote-text');
            return `<p class="dot-item">${caption}</p>`;
        }
    });

});


(function () {
  // IMPORTANT: must match the cookie your form app creates on submit
  var COOKIE_NAME = "unlocked_files"; // <-- change if your cookie name is different

  var LOCK_SELECTOR = ".non-eco-file-lock";
  var MODAL_ID = "fileLockModal";
  var BACKDROP_ID = "fileLockBackdrop";
  var CLOSE_ID = "fileLockClose";

  var pendingDownloadUrl = null;

  function getCookie(name) {
    var safe = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    var match = document.cookie.match(new RegExp("(^|;\\s*)" + safe + "=([^;]*)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function hasAccess() {
    return !!getCookie(COOKIE_NAME);
  }

  function openModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.style.display = "block";
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.style.display = "none";
  }

  function downloadNow(url) {
    if (!url) return;
    window.open(url, "_blank", "noopener");
  }

  function updateButtons() {
    var unlocked = hasAccess();

    document.querySelectorAll(LOCK_SELECTOR).forEach(function (a) {
      var textEl = a.querySelector(".non-eco-lock-text");
      var lockIcon = a.querySelector(".non-eco-icon-lock");
      var unlockIcon = a.querySelector(".non-eco-icon-unlock");

      if (unlocked) {
        a.classList.add("is-unlocked");
        if (textEl) textEl.textContent = "Download";
        a.setAttribute("aria-label", "Unlocked. Click to download");

        if (lockIcon) lockIcon.style.display = "none";
        if (unlockIcon) unlockIcon.style.display = "inline";
      } else {
        a.classList.remove("is-unlocked");
        if (textEl) textEl.textContent = "Download";
        a.setAttribute("aria-label", "Locked. Click to unlock and download");

        if (lockIcon) lockIcon.style.display = "inline";
        if (unlockIcon) unlockIcon.style.display = "none";
      }
    });
  }

  // Watch for cookie after the user submits the form
  function watchForCookieThenDownload() {
    var tries = 0;
    var maxTries = 80; // ~20 seconds (80 * 250ms)
    var timer = setInterval(function () {
      tries++;

      if (hasAccess()) {
        clearInterval(timer);

        closeModal();
        updateButtons();

        // Download the file user originally clicked
        downloadNow(pendingDownloadUrl);
        pendingDownloadUrl = null;
      } else if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 250);
  }

  function onLockClick(e) {
    var link = e.currentTarget;
    var url = link.getAttribute("href");

    // If cookie exists => allow normal click (download opens)
    if (hasAccess()) return;

    // No cookie => block download, open popup
    e.preventDefault();
    pendingDownloadUrl = url;

    openModal();
    watchForCookieThenDownload();
  }

  function init() {
    document.querySelectorAll(LOCK_SELECTOR).forEach(function (a) {
      a.addEventListener("click", onLockClick);
    });

    var backdrop = document.getElementById(BACKDROP_ID);
    if (backdrop) backdrop.addEventListener("click", closeModal);

    var closeBtn = document.getElementById(CLOSE_ID);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);

    // Set initial lock/unlock state on page load
    updateButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
